import React from 'react';
import PropTypes from 'prop-types';
import ReviewEntry from '../ReviewEntry';


function ReleaseReview({ review }) {
  return (
    <ReviewEntry
      username={review.reviewerName}
      rate={review.reviewRate}
      message={review.reviewData}
      state={review.reviewState}
      country={review.reviewerCountryCode !== '--' ? review.reviewerCountryCode : ''}
    />
  );
}

ReleaseReview.propTypes = {
  review: PropTypes.shape({
    reviewerName: PropTypes.string,
    reviewRate: PropTypes.number,
    reviewData: PropTypes.string,
    reviewState: PropTypes.string,
    reviewerCountryCode: PropTypes.string,
  }).isRequired,
};

export default ReleaseReview;
